<template>
  <div class="history">
    <v-base-card>
      <template v-slot:heading>
        ユーザー(教室)情報 {{title}}
      </template>
      <template v-slot:content>
        <v-account-form @submit="submit" />
      </template>
    </v-base-card>
  </div>
</template>

<script>
import VBaseCard from '@/components/molecules/BaseCard'
import VAccountForm from '@/components/organizms/AccountForm'

export default {
  components: {
    VBaseCard,
    VAccountForm
  },
  data () {
    return {
      loginId: null,
      password: null,
      selected: []
    }
  },

  computed: {
    title() {
      return this.$store.getters['account/title']
    },
  },

  mounted() {
  },
  beforeDestroy() {
    // 画面離れる時、データ初期化
    this.$store.commit('account/initialize')
  },

  methods: {
    async submit() {
      const res = await this.$store.dispatch('account/submit')
      this.$toasted.global.success({ message: res.message })
      this.$router.push('/admin/school')
    }
  }
}
</script>

<style lang="stylus" scoped>

.select
  font-size: 11px !important;
</style>
